import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const ReinferenceIcon = (props) => {
  const { getThemeColor } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M13.2337 4.7625C12.1462 3.675 10.6537 3 8.99616 3C5.68116 3 3.00366 5.685 3.00366 9C3.00366 12.315 5.68116 15 8.99616 15C11.7937 15 14.1262 13.0875 14.7937 10.5H13.2337C12.6187 12.2475 10.9537 13.5 8.99616 13.5C6.51366 13.5 4.49616 11.4825 4.49616 9C4.49616 6.5175 6.51366 4.5 8.99616 4.5C10.2412 4.5 11.3512 5.0175 12.1612 5.835L9.74616 8.25H14.9962V3L13.2337 4.7625Z"
        fill={`${props.color!=undefined && props.color!=null?props.color:getThemeColor("icon-color")}`}
      />
    </svg>
  );
};

export default ReinferenceIcon;
